import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ThemingService {
  themes = ['theme-dark', 'theme-light'];
  theme = new BehaviorSubject('theme-light');
  storedTheme: string | null;

  constructor(private ref: ApplicationRef) {
    const darkModeOn =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.storedTheme = localStorage.getItem('storedTheme');

    if (this.storedTheme == null) {
      if (darkModeOn) {
        this.theme.next('theme-dark');
      }

      window.matchMedia('(prefers-color-scheme: dark)').addListener((e) => {
        const turnOn = e.matches;
        this.theme.next(turnOn ? 'theme-dark' : 'theme-light');

        this.ref.tick();
      });
    } else {
      this.theme.next(this.storedTheme);
    }
  }

  setSelectedTheme(theme: 'theme-dark' | 'theme-light') {
    this.theme.next(theme);
    localStorage.setItem('storedTheme', theme);
  }
}
